import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ChatWidget from './components/ChatWidget';

declare global {
  interface Window {
    DigimChat?: {
      open: () => void;
      close: () => void;
    };
  }
}

const ChatWidgetRoot: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Expose simple global API so index.html buttons can open/close the widget
    window.DigimChat = {
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
    };

    return () => {
      // Clean up on unmount
      if (window.DigimChat) {
        window.DigimChat.open = () => {};
        window.DigimChat.close = () => {};
      }
    };
  }, []);

  return <ChatWidget isOpen={isOpen} setIsOpen={setIsOpen} />;
};

const mountChatWidget = () => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <ChatWidgetRoot />
    </React.StrictMode>
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountChatWidget);
} else {
  mountChatWidget();
}

